import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { Dependency } from "@fiduciaria/Shared/Types/dependency.interface";

import { Option } from "@shared/Entities/General/option.entity";
import { Fideicomiso, NewUserFiduciary } from "src/app/Canales/Shared/Types/new-user";


@Component({
  selector: "app-confirmation-fiduciary",
  templateUrl: "./confirmation-fiduciary.component.html",
  styleUrls: ["./confirmation-fiduciary.component.scss"],
})
export class ConfirmationFiduciaryComponent implements OnChanges {
  @Input() public newUser: NewUserFiduciary | null;
  @Input() public isEditing: boolean = false;
  @Input() public isOperative: boolean = false;
  @Output() public reset = new EventEmitter<void>();
  public roles: string = "";
  public escrows: Fideicomiso[];

  private readonly EDIT_USER_ROUTE = 'editar-usuario-fiduciaria';
  private readonly EDIT_USER_OPERATIONAL_ROUTE = 'editar-usuario-fiduciaria/operational';
  private readonly CREATE_USER_OPERATIONAL_ROUTE = 'create-fiduciary-user-canales/operational';

  constructor(
    private readonly router: Router,
  ) {}

  public ngOnInit(): void {
    this.isEditing = this.router.url.includes(this.EDIT_USER_ROUTE);
    this.isOperative = this.isEditing 
    ? this.router.url.includes(this.EDIT_USER_OPERATIONAL_ROUTE)
    : this.router.url.includes(this.CREATE_USER_OPERATIONAL_ROUTE);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.roles = changes.newUser?.currentValue?.roles?.map((role: Option) => role.nombre).join(", ");
    this.escrows = changes.newUser?.currentValue?.escrows;
  }

  public getDependencias(dependencies: Dependency[]): string {
    return dependencies
      .map(dep => dep.sNombre) 
      .join(", "); 
  }
}
